<template>
  <div class="followlist">
    <div class="followlist-m">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        @submit.native.prevent
      >
        <el-form-item label="设备编号">
          <el-input
            v-model.trim="formInline.inputdeviceno"
            placeholder="请输入设备编号"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            plain
            @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="warning"
            plain
            class="el-icon-setting"
            @click="showYsConfig"
            >萤石云配置</el-button
          >
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <div class="table-page">
          <el-table
            :data="list"
            style="width: 100%"
            :row-style="tableRowStyle"
            :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
            :header-cell-style="tableHeaderColor"
          >
            <el-table-column
              label="设备编号"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.deviceSerial }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="设备名称"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.deviceName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="设备类型"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.deviceType }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="设备状态"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  style="margin-left: 10px; color: #85ce61"
                  v-if="scope.row.status == 1"
                  >在线</span
                >
                <span style="margin-left: 10px; color: #f78989" v-else>
                  离线
                </span>
              </template>
            </el-table-column>
            <!-- <el-table-column
              label="验证码"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">
                  {{ scope.row.code }}
                </span>
              </template>
            </el-table-column> -->
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <!-- icon="el-icon-edit" -->
                <!-- <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                > -->

                <!-- icon="el-icon-delete" -->
                <!-- <el-button
                  type="danger"
                  size="mini"
                  plain
                  @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button
                > -->
                <!-- icon="el-icon-goods" -->
                <el-button
                  type="success"
                  size="mini"
                  plain
                  @click="bindAilse(scope.$index, scope.row)"
                  >通道</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
      <!-- 弹出新增 -->
      <el-dialog
        title="新增设备信息"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="followxz"
        @close="closexz"
      >
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item
            label="设备编号"
            :label-width="formLabelWidth"
            prop="xzdate"
          >
            <el-input
              v-model.trim="form.xzdate"
              placeholder="请输入设备编号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备名称"
            :label-width="formLabelWidth"
            prop="xzname"
          >
            <el-input
              v-model.trim="form.xzname"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="验证码"
            :label-width="formLabelWidth"
            prop="code"
          >
            <el-input
              v-model.trim="form.code"
              placeholder="请输入验证码"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备描述"
            :label-width="formLabelWidth"
            prop="xzsec"
          >
            <el-input
              v-model.trim="form.xzsec"
              type="textarea"
              :rows="3"
              placeholder="请输入设备描述"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelxz">取 消</el-button>
          <el-button
            type="primary"
            @click="submitForm('form')"
            :loading="addLoading"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- 弹出修改 -->
      <el-dialog
        title="修改设备信息"
        :visible.sync="dialogFormEdit"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="followedit"
      >
        <el-form ref="formedit" :model="formedit" :rules="rules">
          <el-form-item
            label="设备编号"
            :label-width="formLabelWidth"
            prop="editdate"
          >
            <el-input
              disabled
              v-model.trim="formedit.editdate"
              auto-complete="off"
              placeholder="请输入设备编号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备名称"
            :label-width="formLabelWidth"
            prop="editname"
          >
            <el-input
              v-model.trim="formedit.editname"
              auto-complete="off"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="验证码"
            :label-width="formLabelWidth"
            prop="editcode"
          >
            <el-input
              v-model.trim="formedit.editcode"
              placeholder="请输入验证码"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备描述"
            :label-width="formLabelWidth"
            prop="editsec"
          >
            <el-input
              v-model.trim="formedit.editsec"
              auto-complete="off"
              type="textarea"
              :rows="3"
              placeholder="请输入设备描述"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="dialogFormEdit = false">取 消</el-button>
          <el-button
            type="primary"
            @click="submitFormEdit('formedit')"
            :loading="editLoading"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  data() {
    return {
      addLoading: false,
      BindLoading: false,
      editLoading: false,
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      deviceno: "",
      list: [], //返回的结果集合
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      formInline: {
        inputdeviceno: "",
      },
      // 新增表单dialog
      dialogFormVisible: false,
      dialogVisible: false,
      form: {
        xzdate: "",
        xzsec: "",
        xzname: "",
        code: "",
      },
      formLabelWidth: "120px",
      //修改表单dialog
      dialogFormEdit: false,
      formedit: {
        editdate: "",
        editname: "",
        editcode: "",
        editsec: "",
      },
      //绑定设备表单dialog
      dialogFormBind: false,
      formbind: {
        binddate: "",
        userId: "",
      },
      bindOptions: [],
      rules: {
        // 新增正则验证匹配规则
        xzdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          //可以设置双重验证标准
          //{min: 5, max:15, message: '长度在 5到 15 个字符'},
          // { pattern: /^[A-Za-z0-9_]+$/, message: '请输入由数字、字母、下划线组成的字符' }
          //{ pattern: /^[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' },
          //{ pattern: /^HC/, message: '请输入由HC开头的字符' }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" }, //by  guo 2020-4-26-18:12修改
        ],
        xzname: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          //可以设置双重验证标准
          { min: 1, max: 30, message: "长度在 1到 30 个字符" },
        ],
        code: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          //可以设置双重验证标准
          { min: 1, max: 30, message: "长度在 1到 30 个字符" },
        ],
        xzsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 100, message: "长度在 1到 100 个字符" },
        ],

        // 修改正则验证匹配规则
        editdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          //可以设置双重验证标准
          //{ min: 5, max:15,  message: '长度在 5到 15 个字符', },
          // { pattern: /^[A-Za-z0-9_]+$/, message: '请输入由数字、字母、下划线组成的字符' }
          //{ pattern: /^[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' }
          // { pattern: /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[_-])[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" }, //by  guo 2020-4-26-18:12修改
        ],
        editname: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          //可以设置双重验证标准
          { min: 1, max: 30, message: "长度在 1到 30 个字符" },
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ],
        editcode: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          //可以设置双重验证标准
          { min: 1, max: 30, message: "长度在 1到 30 个字符" },
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ],
        editsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 100, message: "长度在 1到 100 个字符" },
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ],

        // 绑定设备
        binddate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
        ],
        userId: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "change", //何事件触发
          },
        ],
      },
      fileFlag: false,
    };
  },
  methods: {
    //显示萤石云配置
    showYsConfig(){
      bus.$emit("homePage", {
            type: "jump",
            path: "/cameraAppInfo",
      });
    },
    //点击查询
    onSubmit(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (this.formInline.inputdeviceno == "") {
        this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
      } else {
        this.getTableData(
          this.formInline.inputdeviceno,
          (this.pageNum = 1),
          (this.pageSize = 10)
        );
      }
    },

    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.inputdeviceno != null) {
        if (this.formInline.inputdeviceno == "") {
          this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
        } else {
          this.getTableData(
            this.formInline.inputdeviceno,
            (this.pageNum = 1),
            (this.pageSize = 10)
          );
        }
      }
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    // 摄像头通道
    bindAilse(index, row) {
      bus.$emit("homePage", {
            type: "jump",
            path: "/cameraAisse",
            params:{
              id: row.id,
              no:row.deviceSerial
            }
      });
    },

    // 点击弹出修改信息的弹窗
    handleEdit(index, row) {
      (this.dialogFormEdit = true), //打开修改弹窗
        console.log(index, row);
      this.listIndex = index; //记录索引
      console.log(this.listIndex);
      // this.formedit=row;//记录数据
      this.formedit = Object.assign({}, row); //深拷贝记录
      console.log(this.formedit.id);
      //将对应行所对的表格值赋给input框
      this.$set(this.formedit, "editdate", row.deviceNo);
      this.$set(this.formedit, "editsec", row.remark);
      this.$set(this.formedit, "editname", row.deviceName);
      this.$set(this.formedit, "editcode", row.code);
      console.log(row.code);
      console.log(this.formedit.editcode);
    },

    //点击修改弹窗的 确定按钮提交修改的数据
    submitFormEdit(datainfo) {
      //正则匹配规则rules
      this.$refs[datainfo].validate((valid) => {
        //判断数据是否存在
        if (valid) {
          let param = {
            id: this.formedit.id,
            remark: this.formedit.editsec,
            deviceName: this.formedit.editname,
            deviceNo: this.formedit.editdate,
            code: this.formedit.editcode,
          };
          console.log(param);
          this.editLoading = true;
          this.$postJson("dmc/yingShiCamera/edit", param).then((res) => {
            console.log(res);
            this.editLoading = false;
            this.dialogFormEdit = false; //关闭修改弹窗
            // this.$bus.$emit("submitFormEditchange_follow"); //发送一个change事件
            this.getTableData();
            if (res.code == "200") {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "success",
                });
              }, 300);
              console.log("修改成功!");
            } else {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }, 300);
            }
            //console.log(this.$store.state.count)
          });
        } else {
          console.log("修改失败!");
          return false;
        }
      });
    },

    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false,
      })
        .then(() => {
          console.log(index, row);
          let id = row.id;
          console.log(id);
          this.$postForm("dmc/yingShiCamera/deleteById/" + id).then((res) => {
            if (res.code == 200) {
              this.getTableData();
              console.log(res);
              this.$message({
                type: "success",
                message: res.message,
              });
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //关闭新增的dialog
    closexz() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //点击新增取消  重置表单以及验证
    cancelxz() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //新增弹出框点击确定提交信息
    submitForm(datainfo) {
      this.$refs[datainfo].validate((valid) => {
        if (valid) {
          let param = {
            remark: this.form.xzsec,
            deviceName: this.form.xzname,
            deviceNo: this.form.xzdate,
            code: this.form.code,
          };
          console.log(param);
          //this.loading = true
          this.addLoading = true;
          this.$postJson("dmc/yingShiCamera/save", param)
            .then((res) => {
              //旧: dmc/follow/add
              console.log(res);
              this.addLoading = false;
              this.dialogFormVisible = false;
              this.$refs.form.resetFields(); //移除校验结果并重置字段值
              // this.$bus.$emit("submitFormchange_follow"); //发送一个change事件
              this.getTableData();
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success",
                  });
                }, 300);
                console.log("提交成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error",
                  });
                }, 300);
              }
              //console.log(this.$store.state.count)
              //this.loading = false
            })
            .catch((res) => {
              this.$message({
                type: "error",
                message: res.message,
              });
            });
        } else {
          console.log("提交失败!");
          return false;
        }
      });
    },

    //获取表格数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceNo: this.formInline.inputdeviceno,
      };
      console.log(param);
      this.loading = true;
      this.$postJson("dmc/yingShiCamera/queryListWithPage", param).then(
        (res) => {
          console.log(res);
          //判断是否有数据
          if (res.result.list.length != 0) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            this.list = res.result.list;
            //this.$set(this.tableData,res.result.list)
            console.log(this.list);
            setTimeout(() => {
              this.loading = false;
            }, 500);
          } else {
            this.list = [];
            this.totalDataNumber = 0;
            setTimeout(() => {
              this.loading = false;
            }, 3000);
          }
        }
      );
    },

    //初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    },
  },

  mounted() {
    this.getTableData();
  },
};
</script>
<style lang="scss" scoped>
.followlist {
  .followlist-m {
    padding: 10px 0 0 5px;
  }
}

// 修改element-ui默认的样式
.del {
  color: red !important;
}
.fangqu {
  color: green !important;
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
//  ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

//新增的dialog
@media screen and (min-width: 1200px) {
  ::deep .followxz .el-dialog {
    width: 30% !important;
  }
}

//修改的dialog
@media screen and (min-width: 1200px) {
  ::deep .followedit .el-dialog {
    width: 30% !important;
  }
}
</style>
